"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.or = exports.and = void 0;
function and(f, g) {
    return (x) => !!(f(x) && g(x));
}
exports.and = and;
function or(f, g) {
    return (x) => !!(f(x) || g(x));
}
exports.or = or;
//# sourceMappingURL=logic.js.map